import { render, staticRenderFns } from "./reservations-list.vue?vue&type=template&id=07a558d2"
import script from "./reservations-list.vue?vue&type=script&lang=js"
export * from "./reservations-list.vue?vue&type=script&lang=js"
import style0 from "./reservations-list.vue?vue&type=style&index=0&id=07a558d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports